import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './api/axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/reset.css';
import './assets/style/common.css';
import BaiduMap from 'vue-baidu-map'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(BaiduMap, {
  ak: 'a4fFDUAVCrWLOaDRpYGwLeuv36rrX8zq'
})


new Vue({
  router,
  axios,
  render: h => h(App)
}).$mount('#app')
